import React from 'react'
import MyTableNotFound from '../../../../UI/table/MyTableNotFound'
import MyTable from '../../../../UI/table/MyTable'
import { TableCell } from '@mui/material'
import SupplyBillPaymentItem from './SupplyBillPaymentItem'
import { useSelector } from 'react-redux'

const SupplyBillPaymentTable = ({ supplyBillId }) => {

    const supplyBill = useSelector(state => state.supplyBill.supplyBill)

  return (
    <MyTable
        head={
            <>
                <TableCell align="center">№ (ID)</TableCell>
                <TableCell align="center">Рахунок №</TableCell>
                <TableCell align="center">Тип</TableCell>
                <TableCell align="center">Статус</TableCell>
                <TableCell align="center">Дії</TableCell>
            </>
        }
        body={
            // billPayments && billPayments.length > 0 ?
            //     billPayments.map((billPayment, index) => 
            supplyBill.payments && supplyBill.payments.length > 0 ?
                supplyBill.payments.map((billPayment, index) => 
                    <SupplyBillPaymentItem
                        key={billPayment.id}
                        index={index}
                        supplyBillId={supplyBillId}
                        billPayment={billPayment} 
                        // checked={checked}
                        // setChecked={setChecked}
                    />
                )
            : 
                <MyTableNotFound
                    text='Оплат не знайдено' 
                    // columns={6}
                />
        }
        name='оплат'
        hidePagination={true}
    />
  )
}

export default SupplyBillPaymentTable